(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["business-section"] && !Shopify.designMode) return;
  try {
    
let openPopup = document.querySelector(".cta-contact button")
let closePopup = document.querySelector(".close-popup")
if (openPopup && document.querySelector(".form-popup")) {
  document.addEventListener("click", (e) => { 
      let target = document.querySelector(".form-popup.active iframe")
      let target2 = document.querySelector(".cta-contact button")
      if(target) {
        let withinBoundaries = event.composedPath().includes(target)
        let withinBoundaries2 = event.composedPath().includes(target2)
        if (withinBoundaries || withinBoundaries2) { 
            console.log('Click happened inside element')
        } else {
            console.log('Click happened **OUTSIDE** element')
            document.querySelector(".form-popup").classList.remove("active")
        }
      }
  })

  openPopup.addEventListener("click", (e) => {
      //openPopup.classList.add("active")
      document.querySelector(".form-popup").classList.add("active")
  })

  closePopup.addEventListener("click", (e) => {
      //openPopup.classList.add("active")
      document.querySelector(".form-popup").classList.remove("active")
  })
} 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flat-campaign-fourth-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const bgImg = document.querySelector('.bubble-romance__bg-img');

  function toggleSideFade() {
    if (!bgImg) return;
    if (bgImg.clientWidth >= 1440) {
      bgImg.classList.add('has-side-fade');
    } else {
      bgImg.classList.remove('has-side-fade');
    }
  }

  toggleSideFade();

  window.addEventListener('resize', toggleSideFade);

  if (bgImg) {
    bgImg.addEventListener('load', toggleSideFade);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flat-campaign-second-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const section = document.querySelector('.bubble-education');
  if (!section) return;

  const heading = section.querySelector('.bubble-education__heading');
  const subheading = section.querySelector('.bubble-education__subheading');
  const bodies = section.querySelectorAll('.bubble-education__body');

  function applyMobileStyles() {
    if (window.innerWidth <= 768) {
      if (heading && heading.dataset.mobileSize) {
        heading.style.setProperty('--heading-size-mobile', heading.dataset.mobileSize);
        heading.style.setProperty('--heading-spacing-mobile', heading.dataset.mobileSpacing);
      }
      if (subheading && subheading.dataset.mobileSize) {
        subheading.style.setProperty('--subheading-size-mobile', subheading.dataset.mobileSize);
        subheading.style.setProperty('--subheading-spacing-mobile', subheading.dataset.mobileSpacing);
      }
      bodies.forEach(body => {
        if (body.dataset.mobileSize) {
          body.style.setProperty('--body-size-mobile', body.dataset.mobileSize);
          body.style.setProperty('--paragraph-gap-mobile', body.dataset.mobileSpacing);
        }
      });
    }
  }

  applyMobileStyles();
  window.addEventListener('resize', applyMobileStyles);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flat-campaign-third-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const sectionEl = document.currentScript.closest('.shopify-section');
  if (!sectionEl) return;

  const heading = sectionEl.querySelector('.holiday-bubble-hero__heading');
  const subheadings = sectionEl.querySelectorAll('.holiday-bubble-hero__subheading');
  const button = sectionEl.querySelector('.holiday-bubble-hero__button');
  const bgImg = sectionEl.querySelector('.holiday-bubble-hero__bg-img');
  const countdown = sectionEl.querySelector('#holiday-countdown-{{ section.id }}');

  function applyMobileStyles() {
    if (window.innerWidth <= 768) {
      if (heading && heading.dataset.mobileSize) {
        heading.style.setProperty('--heading-size-mobile', heading.dataset.mobileSize);
        heading.style.setProperty('--heading-spacing-mobile', heading.dataset.mobileSpacing);
      }
      subheadings.forEach(function(sub) {
        if (sub.dataset.mobileSize) {
          sub.style.setProperty('--subheading-size-mobile', sub.dataset.mobileSize);
          sub.style.setProperty('--subheading-spacing-mobile', sub.dataset.mobileSpacing);
        }
      });
      if (button && button.dataset.mobileSize) {
        button.style.setProperty('--button-size-mobile', button.dataset.mobileSize);
      }
    }
  }

  function toggleSideFade() {
    if (!bgImg) return;
    if (window.innerWidth >= 1440) {
      bgImg.classList.add('has-side-fade');
    } else {
      bgImg.classList.remove('has-side-fade');
    }
  }

  function initCountdown() {
    if (!countdown) return;

    const targetString = '{{ section.settings.countdown_target }}';
    const targetDate = new Date(targetString);
    const circumference = 301.59;

    function updateCountdown() {
      const now = new Date();
      let diff = targetDate - now;

      if (diff <= 0) {
        countdown.querySelector('[data-days]').textContent = '0';
        countdown.querySelector('[data-hours]').textContent = '0';
        countdown.querySelector('[data-minutes]').textContent = '0';
        countdown.querySelector('[data-seconds]').textContent = '0';
        countdown.querySelectorAll('[data-progress]').forEach(function(circle) {
          circle.style.strokeDashoffset = '0';
        });
        return;
      }

      const totalSeconds = Math.floor(diff / 1000);
      const days = Math.floor(totalSeconds / (60 * 60 * 24));
      const hours = Math.floor((totalSeconds % (60 * 60 * 24)) / (60 * 60));
      const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
      const seconds = totalSeconds % 60;

      countdown.querySelector('[data-days]').textContent = days;
      countdown.querySelector('[data-hours]').textContent = hours;
      countdown.querySelector('[data-minutes]').textContent = minutes;
      countdown.querySelector('[data-seconds]').textContent = seconds;

      const daysProgress = (days % 30) / 30;
      const hoursProgress = (hours % 24) / 24;
      const minutesProgress = (minutes % 60) / 60;
      const secondsProgress = (seconds % 60) / 60;

      countdown.querySelector('[data-progress="days"]').style.strokeDashoffset = circumference * (1 - daysProgress);
      countdown.querySelector('[data-progress="hours"]').style.strokeDashoffset = circumference * (1 - hoursProgress);
      countdown.querySelector('[data-progress="minutes"]').style.strokeDashoffset = circumference * (1 - minutesProgress);
      countdown.querySelector('[data-progress="seconds"]').style.strokeDashoffset = circumference * (1 - secondsProgress);
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  }

  applyMobileStyles();
  toggleSideFade();
  initCountdown();

  window.addEventListener('resize', function() {
    applyMobileStyles();
    toggleSideFade();
  });

  if (bgImg) {
    bgImg.addEventListener('load', toggleSideFade);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('.disclosure__list-wrapper'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    const shouldClose2 = event.relatedTarget && event.relatedTarget.nodeName === 'MAIN';
    if (event.relatedTarget === null || shouldClose || shouldClose2) {
      this.hidePanel();
    }
  }
}

customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holiday-campaign-fourth-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const bgImg = document.querySelector('.bubble-romance__bg-img');

  function toggleSideFade() {
    if (!bgImg) return;
    if (bgImg.clientWidth >= 1440) {
      bgImg.classList.add('has-side-fade');
    } else {
      bgImg.classList.remove('has-side-fade');
    }
  }

  toggleSideFade();

  window.addEventListener('resize', toggleSideFade);

  if (bgImg) {
    bgImg.addEventListener('load', toggleSideFade);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holiday-campaign-second-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const section = document.querySelector('.bubble-education');
  if (!section) return;

  const heading = section.querySelector('.bubble-education__heading');
  const subheading = section.querySelector('.bubble-education__subheading');
  const bodies = section.querySelectorAll('.bubble-education__body');

  function applyMobileStyles() {
    if (window.innerWidth <= 768) {
      if (heading && heading.dataset.mobileSize) {
        heading.style.setProperty('--heading-size-mobile', heading.dataset.mobileSize);
        heading.style.setProperty('--heading-spacing-mobile', heading.dataset.mobileSpacing);
      }
      if (subheading && subheading.dataset.mobileSize) {
        subheading.style.setProperty('--subheading-size-mobile', subheading.dataset.mobileSize);
        subheading.style.setProperty('--subheading-spacing-mobile', subheading.dataset.mobileSpacing);
      }
      bodies.forEach(body => {
        if (body.dataset.mobileSize) {
          body.style.setProperty('--body-size-mobile', body.dataset.mobileSize);
          body.style.setProperty('--paragraph-gap-mobile', body.dataset.mobileSpacing);
        }
      });
    }
  }

  applyMobileStyles();
  window.addEventListener('resize', applyMobileStyles);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holiday-campaign-third-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const sectionEl = document.currentScript.closest('.shopify-section');
  if (!sectionEl) return;

  const heading = sectionEl.querySelector('.holiday-bubble-hero__heading');
  const subheadings = sectionEl.querySelectorAll('.holiday-bubble-hero__subheading');
  const button = sectionEl.querySelector('.holiday-bubble-hero__button');
  const bgImg = sectionEl.querySelector('.holiday-bubble-hero__bg-img');
  const countdown = sectionEl.querySelector('#holiday-countdown-{{ section.id }}');

  function applyMobileStyles() {
    if (window.innerWidth <= 768) {
      if (heading && heading.dataset.mobileSize) {
        heading.style.setProperty('--heading-size-mobile', heading.dataset.mobileSize);
        heading.style.setProperty('--heading-spacing-mobile', heading.dataset.mobileSpacing);
      }
      subheadings.forEach(function(sub) {
        if (sub.dataset.mobileSize) {
          sub.style.setProperty('--subheading-size-mobile', sub.dataset.mobileSize);
          sub.style.setProperty('--subheading-spacing-mobile', sub.dataset.mobileSpacing);
        }
      });
      if (button && button.dataset.mobileSize) {
        button.style.setProperty('--button-size-mobile', button.dataset.mobileSize);
      }
    }
  }

  function toggleSideFade() {
    if (!bgImg) return;
    if (window.innerWidth >= 1440) {
      bgImg.classList.add('has-side-fade');
    } else {
      bgImg.classList.remove('has-side-fade');
    }
  }

  function initCountdown() {
    if (!countdown) return;

    const targetString = '{{ section.settings.countdown_target }}';
    const targetDate = new Date(targetString);
    const circumference = 301.59;

    function updateCountdown() {
      const now = new Date();
      let diff = targetDate - now;

      if (diff <= 0) {
        countdown.querySelector('[data-days]').textContent = '0';
        countdown.querySelector('[data-hours]').textContent = '0';
        countdown.querySelector('[data-minutes]').textContent = '0';
        countdown.querySelector('[data-seconds]').textContent = '0';
        countdown.querySelectorAll('[data-progress]').forEach(function(circle) {
          circle.style.strokeDashoffset = '0';
        });
        return;
      }

      const totalSeconds = Math.floor(diff / 1000);
      const days = Math.floor(totalSeconds / (60 * 60 * 24));
      const hours = Math.floor((totalSeconds % (60 * 60 * 24)) / (60 * 60));
      const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
      const seconds = totalSeconds % 60;

      countdown.querySelector('[data-days]').textContent = days;
      countdown.querySelector('[data-hours]').textContent = hours;
      countdown.querySelector('[data-minutes]').textContent = minutes;
      countdown.querySelector('[data-seconds]').textContent = seconds;

      const daysProgress = (days % 30) / 30;
      const hoursProgress = (hours % 24) / 24;
      const minutesProgress = (minutes % 60) / 60;
      const secondsProgress = (seconds % 60) / 60;

      countdown.querySelector('[data-progress="days"]').style.strokeDashoffset = circumference * (1 - daysProgress);
      countdown.querySelector('[data-progress="hours"]').style.strokeDashoffset = circumference * (1 - hoursProgress);
      countdown.querySelector('[data-progress="minutes"]').style.strokeDashoffset = circumference * (1 - minutesProgress);
      countdown.querySelector('[data-progress="seconds"]').style.strokeDashoffset = circumference * (1 - secondsProgress);
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  }

  applyMobileStyles();
  toggleSideFade();
  initCountdown();

  window.addEventListener('resize', function() {
    applyMobileStyles();
    toggleSideFade();
  });

  if (bgImg) {
    bgImg.addEventListener('load', toggleSideFade);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-single-filter"] && !Shopify.designMode) return;
  try {
    
  ScrollTrigger.create({
      trigger: '.i-filter-hero',
      start: 'top+=100%',
      end: 'bottom',
      endTrigger: '.footer',
      scrub: true,
      markers: false,
      toggleClass: {
      targets: ".header-wrapper",
      className: "header-active"
      }
  });

  document.querySelector('.i-filter-hero').addEventListener('click', () => {
      window.scrollTo({
        top: window.innerHeight,
        behavior: "smooth",
      });
    });

  } catch(e) { console.error(e); }
})();
})();
